module.exports = __webpack_public_path__ + "img/home-setting-active-2.ec6274db.png";